import { createPlugin } from '@backstage/core-plugin-api';

export const guestTechDocsAddonsPlugin = createPlugin({
  id: 'guest-techdocs-addons',
});
